import React from "react";
import { showToastMessage } from "../utils/helper";

 export const ErrorToast =  (data, Component) => {
  showToastMessage("error", data.errors ? (<Component errors={data.errors} />) : data.message);
} 

